/**
 * Response body received from the architecture API endpoints.
 * Deserialized from JSON by kotlinx.serialization via Ktor's ContentNegotiation.
 */
package org.moxultimate.topwithmox.architecture.data

import kotlinx.serialization.SerialName
import kotlinx.serialization.Serializable

@Serializable
data class ArchitectureResponse(
    @SerialName("id") val id: Int,
    @SerialName("name") val name: String,
    @SerialName("description") val description: String,
    @SerialName("type") val type: String,
    @SerialName("created_at") val createdAt: String? = "",
)
